import { Injectable, inject } from '@angular/core';
import {
  ActivationStart,
  GuardsCheckEnd,
  GuardsCheckStart,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  ResolveEnd,
  ResolveStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { pageLoadDebugEnabled, pageLoadLog } from '../lib/page-load-debug';

@Injectable({
  providedIn: 'root',
})
export class PageLoadDebugService {
  private router = inject(Router);

  private routerEvents = pageLoadDebugEnabled
    ? this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) pageLoadLog(`router: navigation start ${event.url}`);
        else if (event instanceof RouteConfigLoadStart) pageLoadLog(`router: lazy load start '${event.route.path}'`);
        else if (event instanceof RouteConfigLoadEnd) pageLoadLog(`router: lazy load end '${event.route.path}'`);
        else if (event instanceof GuardsCheckStart) pageLoadLog('router: guards start');
        else if (event instanceof ActivationStart) {
          const config = event.snapshot.routeConfig;
          const guards = (config?.canActivate || [])
            .map(guard => (typeof guard === 'function' ? guard.name : String(guard)))
            .join(', ');
          pageLoadLog(`router: guards for '${config?.path}'`, guards || '(none)');
        } else if (event instanceof GuardsCheckEnd) pageLoadLog(`router: guards end (pass: ${event.shouldActivate})`);
        else if (event instanceof ResolveStart) pageLoadLog('router: resolvers start');
        else if (event instanceof ResolveEnd) pageLoadLog('router: resolvers end');
        else if (event instanceof NavigationEnd) pageLoadLog(`router: navigation end ${event.urlAfterRedirects}`);
        else if (event instanceof NavigationCancel) pageLoadLog(`router: navigation cancel ${event.url}`, event.reason);
        else if (event instanceof NavigationError) pageLoadLog(`router: navigation error ${event.url}`, event.error);
      })
    : undefined;
}
